//全局事件总线
import Vue from 'vue'
export const EventBus = new Vue()
